<!--fkdialog+importTable的组合-->
<template>
  <div class="importMatrix">
    <div class="relative">
      <Input class="input-box" v-model="inputData" placeholder="" :disabled='readonly'>
        <i slot="suffix" class="iconfont icon-shangchuan cursor-pointer"></i>
      </Input>
      <div v-if='!readonly' class="import-Box cursor-pointer" @click="importBoxOpen">
        <div>
          <div v-if="importLen">已经上传{{ importLen }}条</div>
        </div>
      </div>
    </div>
    <OmsDialog
        :closable="importTable.closable"
        :component-data="importTable.componentData"
        :draggable="importTable.draggable"
        :exclude-string="importTable.excludeString"
        :keep-alive="importTable.keepAlive"
        :mask="importTable.mask"
        :mask-closable="importTable.maskClosable"
        :name="importTable.name"
        :scrollable="importTable.scrollable"
        :title="importTable.confirmTitle"
        :title-align="importTable.titleAlign"
        :transfer="importTable.transfer"
        :url="importTable.url"
        :width="importTable.width"
    />
  </div>
</template>

<script>
// import businessDialog from 'professionalComponents/businessDialog';

export default {
  name: 'importMatrix',
  components: {
    // businessDialog,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    inputData(v) {
      const data = v || [];
      this.$emit('change', data);
    },
  },
  data() {
    return {
      importLen: 0,
      inputData: '',
      readonly: false,
    };
  },
  computed: {
    // 弹框配置 导入
    importTable() {
      const _this = this;
      return {
        refFuns: 'confirmFun',
        confirmTitle: '排除会员导入',
        titleAlign: 'center', // 设置标题是否居中 center left
        width: '600',
        scrollable: false, // 是否可以滚动
        closable: true, // 是否可以按esc关闭
        draggable: true, // 是否可以拖动
        mask: true, // 是否显示遮罩层
        maskClosable: true, // 是否可以点击叉号关闭
        transfer: true, // 是否将弹层放在body内
        name: 'importTable', // 组件名称
        url: 'modal/publicDialog/importTable',
        keepAlive: true,
        excludeString: 'importTable', // 将name传进去，确认不缓存
        componentData: {
          tableName: this.$route.params.tableName,
          returnData(data) {
            const res = data.excelContent || [];
            console.log(888, res);
            _this.inputData = JSON.stringify(res);
            _this.importLen = res.length;
          },
        },
      };
    },
  },
  mounted() {
    const defaultData = this.options.valuedata || '';
    console.log('排除会员初始值', defaultData);
    this.inputData = defaultData;
    this.importLen = defaultData ? JSON.parse(defaultData).length : 0;

    // 是否可编辑
    const str = this.$route.path.split('/');
    const formData = document.querySelector(`#${str[4]}-${str[5]}-${str[6]}`).__vue__
    this.readonly = Boolean(formData.readonly)
  },

  methods: {
    // 打开导入弹窗
    importBoxOpen() {
      this.$children.find((item) => item.name === 'importTable').openConfirm();
    },
  },
};
</script>

<style lang="less">
.import-Box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 999;
  padding: 1px;

  & > div {
    border-radius: 3px;
    background-color: #fff;
    width: calc(100% - 30px);
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 7px;
  }
}
</style>
